import { saveAs } from 'file-saver'
import SwalCustomSuccess from '../alert/swal-success'
import { createSpreadsheetBlob } from './spreadsheet/write-spreadsheet'
import { buildSimpleExportSheet } from './spreadsheet/simple-export'

export async function ExportExcelLip({
  header,
  dataExcel,
  fileName = 'excel'
}) {
  const { sheetData, sheetOptions } = buildSimpleExportSheet({
    header,
    data: dataExcel
  })
  const blob = await createSpreadsheetBlob(sheetData, sheetOptions)

  saveAs(blob, `${fileName}.xlsx`)
  SwalCustomSuccess()
}
